export default __webpack_public_path__ + "static/media/dot-dashedLine.f92e0d63.svg";